import type {RouteLocationNormalized} from 'vue-router'

export const OVERLAY_ROUTE_QUERY = {stackable: 'true'}

export function isOpenedAsOverlay(route: RouteLocationNormalized): boolean {
  return route.query.stackable === OVERLAY_ROUTE_QUERY.stackable
}
